import type { RefObject } from 'react';
import eases from '../../../util/animation/eases';
import type { ImageRef } from '../../atoms/image/Image.data';
import { revealRectangle } from '../../../util/animation/reveal/reveal';

interface HorizontalCreativityRefs {
  elementRef?: RefObject<HTMLElement | null>;
  title1Ref?: RefObject<HTMLHeadingElement | null>;
  title2Ref?: RefObject<HTMLHeadingElement | null>;
  titleOutline1Ref?: RefObject<HTMLHeadingElement | null>;
  titleOutline2Ref?: RefObject<HTMLHeadingElement | null>;
  slidesRef?: RefObject<Array<HTMLDivElement> | null>;
  slideImagesRef?: RefObject<Array<ImageRef> | null>;
  shapeInnerRef?: RefObject<HTMLDivElement | null>;
  imageRef?: RefObject<ImageRef | null>;
  shapeRef?: RefObject<HTMLDivElement | null>;
}

export function setupTitleTimeline(
  timeline: gsap.core.Timeline,
  { title1Ref, title2Ref, titleOutline1Ref, titleOutline2Ref, shapeRef }: HorizontalCreativityRefs,
): void {
  const yOffset = window.innerWidth >= 768 ? 250 : -80; // window.innerWidth >= 768  ? 250 : 100;

  if (shapeRef?.current) {
    timeline.fromTo(
      shapeRef.current,
      { y: yOffset },
      { y: -yOffset, ease: 'none', duration: 1 },
      0,
    );
  }

  const titleOffsetY = window.innerWidth >= 768 ? -150 : 20;
  // -80 , 50

  if (titleOutline1Ref?.current && titleOutline2Ref?.current) {
    timeline.fromTo(
      [titleOutline1Ref?.current, titleOutline2Ref?.current],
      { y: -yOffset - titleOffsetY },
      { y: yOffset + titleOffsetY, ease: 'none', duration: 1 },
      0,
    );
  }

  if (title1Ref?.current && title2Ref?.current) {
    timeline.fromTo(
      [title1Ref?.current, title2Ref?.current],
      { y: -titleOffsetY },
      { y: titleOffsetY, ease: 'none', duration: 1 },
      0,
    );
  }

  if (title1Ref?.current && titleOutline1Ref?.current) {
    timeline.fromTo(
      [title1Ref.current, titleOutline1Ref?.current],
      { xPercent: -50 },
      {
        xPercent: 75,
        ease: eases.curveOutInOut1,
        duration: 1,
      },
      0,
    );
  }

  if (title2Ref?.current && titleOutline2Ref?.current) {
    timeline.fromTo(
      [title2Ref?.current, titleOutline2Ref?.current],
      { xPercent: 50 },
      {
        xPercent: -75,
        ease: eases.curveOutInOut1,
        duration: 1,
      },
      0,
    );
  }
}

export function setupSlidesTimeline(
  timeline: gsap.core.Timeline,
  { slidesRef, slideImagesRef, shapeInnerRef, imageRef }: HorizontalCreativityRefs,
): void {
  timeline.addLabel(`slide_-1`);
  if (shapeInnerRef?.current) {
    timeline.add(
      revealRectangle(shapeInnerRef.current, {
        from: 'center-full',
        duration: 0.4,
        ease: 'Quad.easeInOut',
      }),
      0,
    );
  }

  if (imageRef?.current) {
    timeline.fromTo(
      imageRef.current,
      { scale: 1.5 },
      {
        scale: 1,
        clearProps: 'scale',
        ease: 'Quad.easeInOut',
        duration: 0.3,
      },
      '-=0.2',
    );
  }

  if (slidesRef?.current) {
    slidesRef?.current.forEach((item, index) => {
      timeline.addLabel(`slide_${index}`);
      timeline.fromTo(
        item,
        { xPercent: -100, yPercent: 100 },
        {
          xPercent: 0,
          yPercent: 0,
          ease: 'Quad.easeInOut',
          duration: 0.3,
        },
        '>',
      );

      if (slideImagesRef?.current) {
        timeline.fromTo(
          slideImagesRef.current[index],
          { scale: 1.5 },
          {
            scale: 1,
            clearProps: 'scale',
            ease: 'Quad.easeInOut',
            duration: 0.3,
          },
          '<0.2',
        );
      }
    });
  }
  timeline.addLabel(`slide_4`);

  if (shapeInnerRef?.current) {
    // timeline.add(
    //   hideRectangle(shapeInnerRef.current, {
    //     to: 'center-full',
    //     duration: 0.4,
    //     ease: 'Quad.easeInOut',
    //   }),
    //   '>',
    // );
    timeline.addLabel(`slide_5`);
  }
}
